import { generateHTML, JSONContent } from '@tiptap/core'
import clsx from 'clsx'
import { useRef } from 'react'
import { useTranslation } from 'react-i18next'

import type { AnnouncementDetailModalProps } from './type'

import { createAnnouncementEditorExtensions } from '@/components/features/announcement/extensions'
import { Dialog, TextButton } from '@/components/ui'

import styles from './style.module.css'

export const AnnouncementDetailModal = ({
  isOpen,
  onClose,
  data,
}: AnnouncementDetailModalProps) => {
  const { t } = useTranslation()
  const ref = useRef(null)

  return (
    <Dialog
      title={t('announcement.title')}
      isOpen={isOpen}
      initialFocus={ref}
      onClose={onClose}
    >
      <div className={clsx('tw-px-2 tw-pb-2 tw-text-sm')} ref={ref}>
        <div className={clsx('tw-text-gray-600')}>{data.displayDate}</div>
        <div className={clsx('tw-font-bold')}>{data.title}</div>
        <div className={clsx('tw-mt-4', styles.cancelContentPaddingX)}>
          <div className="announcement-editor-content tw-max-h-[50vh] tw-overflow-y-auto">
            <div
              className="ProseMirror preview"
              dangerouslySetInnerHTML={{
                __html: generateHTML(
                  data.body as JSONContent,
                  createAnnouncementEditorExtensions()
                ),
              }}
            />
          </div>
        </div>
        <div className={clsx('tw-mt-4 tw-flex tw-justify-center')}>
          <TextButton onClick={onClose}>{t('announcement.close')}</TextButton>
        </div>
      </div>
    </Dialog>
  )
}
